import { host } from "~/utils/constants";
import {Category} from "~/utils/Category";
import type {Product} from "~/utils/Product";

export class User {
  id = 0;
  username = "";
  email = "";
  confirmed = false
  password? = "placeholder"
  token = ""
  role:any = {}
  billingAddress = ""

  parseJson(ret: { [key: string]: any } ) {
    if(ret){
      this.id = ret.id;
      if(ret.attributes){
        this.username = ret.attributes.username;
        this.email = ret.attributes.email;
        this.confirmed = ret.attributes.confirmed
        this.billingAddress = ret.attributes.billingAddress;
        this.role = ret.attributes.role;
      }
      else{
        this.username = ret.username;
        this.email = ret.email;
        this.confirmed = ret.confirmed
        this.billingAddress = ret.billingAddress;
        this.role = ret.role;
      }
    }
  }
  toApiJSON(){
    const retValue = {...this}
    retValue.role = this.role.id
    if(this.password == "placeholder"){
      retValue.password = undefined
    }
    console.log(retValue)
    return retValue
  }
  toJSON(){
    const retValue = {...this}
    if(this.password == "placeholder"){
      retValue.password = undefined
    }
    console.log(retValue)
    return retValue
  }
}

export const userRoles = [
  {
    name:"Public",
    value:2
  },
  {
    name:"Customer",
    value:3
  },
  {
    name:"Authenticated",
    value:1
  }
]
